/** @format */

import 'src/i18n';
import { createSlice } from '@reduxjs/toolkit';
import axios from 'src/utils/axios';
import { ENDPOINTS } from 'src/constants';
import type { AcademyBookingsResponse, AcademyTrainingsResponse } from 'src/types';

const initialState = {
  trainingsLoading: false,
  trainingsError: false,
  trainings: null,
  bookingsLoading: false,
  bookingsError: false,
  bookings: null
};

const slice = createSlice({
  name: 'contents',
  initialState,
  reducers: {
    getTrainings(state) {
      state.trainingsLoading = true;
      state.trainingsError = null;
    },
    getTrainingsSuccess(state, action) {
      state.trainings = action.payload;
      state.trainingsLoading = false;
      state.trainingsError = null;
    },
    getTrainingsFailure(state, action) {
      state.trainingsLoading = false;
      state.trainingsError = action.payload;
    },
    getBookings(state) {
      state.bookingsLoading = true;
      state.bookingsError = null;
    },
    getBookingsSuccess(state, action) {
      state.bookings = action.payload;
      state.bookingsLoading = false;
      state.bookingsError = null;
    },
    getBookingsFailure(state, action) {
      state.bookingsLoading = false;
      state.bookingsError = action.payload;
    }
  }
});
export const reducer = slice.reducer;

export const getTrainings = () => async dispatch => {
  const { getTrainings, getTrainingsSuccess, getTrainingsFailure } = slice.actions;
  try {
    dispatch(getTrainings());
    const response = await axios.get<AcademyTrainingsResponse>(ENDPOINTS.GET_EVENTS_TRAININGS_ENDPOINT);
    dispatch(getTrainingsSuccess(response?.data));
  } catch (error) {
    dispatch(getTrainingsFailure(error?.message || 'Failed to load trainings'));
  }
};

export const getBookings = () => async dispatch => {
  const { getBookings, getBookingsSuccess, getBookingsFailure } = slice.actions;
  try {
    dispatch(getBookings());
    const response = await axios.get<AcademyBookingsResponse>(ENDPOINTS.GET_EVENTS_BOOKINGS_ENDPOINT);
    dispatch(getBookingsSuccess(response?.data));
  } catch (error) {
    dispatch(getBookingsFailure(error?.message || 'Failed to load bookings'));
  }
};
